import { useCallback } from 'react';
import { SCROLLBAR_HOVER_HIT_PX } from 'styles/scrollbar.styles';

/**
 * HiGrid와 동일한 스크롤바 호버 확장 — 우측·하단 스크롤바 근처일 때 data-scrollbar-hover=1
 * @returns {{ 'data-scrollbar-hover': string, onMouseMove: Function, onMouseLeave: Function }}
 */
export default function useScrollbarHoverProps() {
  const onMouseMove = useCallback((e) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const hasV = el.scrollHeight > el.clientHeight + 1;
    const hasH = el.scrollWidth > el.clientWidth + 1;
    const nearV = hasV && x >= el.clientWidth - SCROLLBAR_HOVER_HIT_PX;
    const nearH = hasH && y >= el.clientHeight - SCROLLBAR_HOVER_HIT_PX;
    const next = nearV || nearH ? '1' : '0';
    if (el.getAttribute('data-scrollbar-hover') !== next) {
      el.setAttribute('data-scrollbar-hover', next);
    }
  }, []);

  const onMouseLeave = useCallback((e) => {
    e.currentTarget.setAttribute('data-scrollbar-hover', '0');
  }, []);

  return {
    'data-scrollbar-hover': '0',
    onMouseMove,
    onMouseLeave,
  };
}
